"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uriMatch = exports.parseUri = exports.parseHref = void 0;
const stringHelpers_1 = require("./stringHelpers");
/**
 * Consistently format URIs, with a leading slash, and no trailing slash
 */
const parseHref = (maybeHref) => {
    if (!maybeHref || !maybeHref.length)
        return {
            external: false,
            href: null,
        };
    // Special case from CraftCMS
    maybeHref = maybeHref === '__home__' ? '/' : (0, stringHelpers_1.trimSlashes)(maybeHref);
    const WEBSITE_HOST = 'example.com';
    const { href: fullUrl, host, pathname, search, hash } = new URL(maybeHref, `https://${WEBSITE_HOST}`);
    const external = host !== WEBSITE_HOST;
    const href = external ? fullUrl : `${pathname}${search}${hash}`;
    return {
        external,
        href,
    };
};
exports.parseHref = parseHref;
const parseUri = (maybeHref) => {
    var _a;
    return (_a = (0, exports.parseHref)(maybeHref).href) !== null && _a !== void 0 ? _a : undefined;
};
exports.parseUri = parseUri;
const uriMatch = (a, b) => {
    return a && a.length && (0, exports.parseHref)(a).href === (0, exports.parseHref)(b).href ? true : false;
};
exports.uriMatch = uriMatch;
